import React from "react";
import { Link } from "react-router-dom";
import MotionAfterHydration from "../MotionAfterHydration";

export default function HomeHero() {
  return (
    <section className="relative isolate min-h-[88vh] overflow-hidden bg-gray-950 text-white">
      <video
        className="absolute inset-0 hidden h-full w-full object-cover brightness-[0.92] contrast-[1.08] saturate-[0.9] motion-safe:block"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        aria-label="MAG Lab AMR and AGV integration footage"
      >
        <source src="/videos/MAG_WEBSITEHERO_Rev05.mp4" type="video/mp4" />
      </video>
      <div
        className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(0,0,0,0.58)_0%,rgba(0,0,0,0.38)_48%,rgba(0,0,0,0.52)_100%)]"
        aria-hidden="true"
      />

      <div className="relative flex min-h-[88vh] flex-col items-center justify-center px-4 py-28 text-center sm:px-6 lg:px-8">
        <MotionAfterHydration
          as="h1"
          className="max-w-5xl text-5xl font-bold tracking-tight text-white sm:text-6xl lg:text-7xl"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55, ease: "easeOut" }}
        >
          Turnkey AGV & AMR Integration
        </MotionAfterHydration>
        <MotionAfterHydration
          as="p"
          className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-white/85 sm:text-xl"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55, ease: "easeOut", delay: 0.12 }}
        >
          A one-stop shop for scoping, engineering, AMR system integration, post launch support and maintenance, and customized operational software.
        </MotionAfterHydration>
        <MotionAfterHydration
          className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: "easeOut", delay: 0.22 }}
        >
          <Link to="/contact" className="btn-primary px-8 py-4 text-base">
            Contact Us
          </Link>
          <Link to="/products-services" className="btn-secondary px-8 py-4 text-base">
            See Solutions
          </Link>
        </MotionAfterHydration>
      </div>
    </section>
  );
}
